import { render, staticRenderFns } from "./section-slots.vue?vue&type=template&id=7134f4cb&"
import script from "./section-slots.vue?vue&type=script&lang=js&"
export * from "./section-slots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports